import { status, StatusType } from '../../typeStatus'

export const GET_VENDOR_ID = 'GET_VENDOR_ID'
export const GET_VENDOR_ID_SUCCEEDED = 'GET_VENDOR_ID_SUCCEEDED'
export const GET_VENDOR_ID_ERROR = 'GET_VENDOR_ID_ERROR'
export const GET_VENDOR_ID_RESET = 'GET_VENDOR_ID_RESET'

export const InitialState: VendorState = {
  vendorId: null,
  vendorIdStatus: status.initial,
}

export interface VendorState {
  vendorId: number | null
  vendorIdStatus: StatusType
}

export interface GetVendorId {
  type: typeof GET_VENDOR_ID
  payload: null
}
export interface GetVendorIdSucceeded {
  type: typeof GET_VENDOR_ID_SUCCEEDED
  payload: number
}
export interface GetVendorIdError {
  type: typeof GET_VENDOR_ID_ERROR
  payload: boolean
}

export interface GetVendorIdReset {
  type: typeof GET_VENDOR_ID_RESET
  payload: null
}

export type VendorActions = GetVendorId | GetVendorIdSucceeded | GetVendorIdError | GetVendorIdReset
